import request from '@/api/config.js'

// Получение информации о категории
export function getAllCategories() {
  return request({
    url: `category`,
    method: 'get',
  })
}

// Добавление категории
export function createCategory(data) {
  return request({
    url: `category/create`,
    method: 'post',
    data,
  })
}

// Получение списка всех категорий по id организации.
// В Network: categories-list
export function getOrgCategories(id, params = {}) {
  return request({
    url: `category/org/${id}/categories-list`,
    method: 'get',
    params,
  })
}

// Обновление категории
export function updateCategory(data) {
  return request({
    url: `category/`,
    method: 'put',
    data,
  })
}

// Удаление категории
export function deleteCategory(id) {
  return request({
    url: `category/${id}`,
    method: 'delete',
  })
}
